
<template>
  <div class="redeemCode">
    <h2>课程兑换</h2>
    <cus-input v-model="code" placeholder="输入课程兑换码">
      <template v-slot:icon>
        <img class="icon" src="/images/ticket/redeem0.png" alt="">
      </template>
    </cus-input>
    <cus-button @click="toUse" class="primary" :disabled="btnDisabled">立即兑换</cus-button>
    <div class="tips">
      <div class="container">
        <span></span>
        <h3>课程兑换说明</h3>
        <span></span>
      </div>
      <p>
        1. 优学课程兑换码，在有效期内可兑换优学优质课程，兑换码已使用或已过期时，不可再兑换课程
        <br>2. 每个兑换码可兑换相应1个专辑课程或多个专辑课程
        <br>3. 如有疑问，可咨询智伴官方客服
        <br>联系电话：
        <span class="tel">400-0004-218</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { isEmpty } from 'lodash';
export default {
  data() {
    const tips = {
      50034: '兑换码已过期',
      50033: '该兑换码已使用，不可再次使用',
      50035: '你已兑换过该课程',
      50038: '兑换码错误，请重新输入',
      50060: '你已兑换过该课程',
    };
    return {
      code: '',
      btnDisabled: true,
      tips,
      list: [],
      albumIds: [],
    };
  },
  watch: {
    code: function(val) {
      this.btnDisabled = val.length !== 8;
    },
  },
  methods: {
    ...mapMutations({
      setLoading: 'setLoadingShow',
    }),
    async toUse() {
      if (!this.isLogin) {
        if (this.isNative) {
          this.$store.dispatch('externalInterface/navigateTo', {
            name: 'login',
          });
        } else {
          this.$router.push({ path: '/account/login-bySMS' });
        }
        return;
      }
      this.setLoading({
        show: true,
      });
      let { albumIds, code } = await this.$api.payment_v1_redeemcode_detail_code_course_list_get({ path: { code: this.code } });
      if (albumIds) {
        let albumList = (await this.$api.api_v3_album_list_by_ids_post({ data: { ids: albumIds } })) || [];
        this.list = albumList.map((item) => {
          return item.name;
        });
      } else {
        this.setLoading({
          show: false,
        });
        if (this.tips[code]) {
          this.$createToast({
            txt: this.tips[code],
            type: 'txt',
          }).show();
        }
        return;
      }
      this.setLoading({
        show: false,
      });
      this.$createDialog(
        {
          type: 'confirm',
          title: '兑换提示',
          confirmBtn: {
            text: '确认',
            active: true,
            disabled: false,
            href: 'javascript:;',
          },
          cancelBtn: {
            text: '取消',
            active: false,
            disabled: false,
            href: 'javascript:;',
          },
          onConfirm: () => {
            this.albumIds = albumIds;
            this.exchange();
          },
        },
        (createElement) => {
          return [
            createElement(
              'p',
              {
                class: {
                  'redeem-content': true,
                },
                slot: 'content',
              },
              '兑换课程：' + this.list.toString().replace(/,/g,'、'),
            ),
          ];
        },
      ).show();
    },
    exchange() {
      this.setLoading({
        show: true,
      });
      this.$api.payment_v1_redeemcode_detail_exchange_post({ data: { code: this.code, userPhone: this.userInfo.phoneNum } }).then((e) => {
        this.setLoading({
          show: false,
        });
        if (e && !this.tips[e.code]) {
          if (this.isNative) {
            this.$store.dispatch('externalInterface/navigateTo', {
              name: 'albumListByIds',
              params: {
                ids: this.albumIds,
              },
            });
          } else {
            this.$router.push({
              path: '/ticket/goodslist',
              query: { ids: encodeURIComponent(this.albumIds.toString()) },
            });
          }
        } else if (this.tips[e.code]) {
          this.$createToast({
            txt: this.tips[e.code],
            type: 'txt',
          }).show();
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      isNative: 'externalInterface/isNative',
      userInfo: 'auth/userInfo',
      isVisitor: 'auth/isVisitor',
    }),
    isLogin() {
      console.info(this.isVisitor);
      console.info(this.userInfo);
      console.info(!this.isVisitor && !isEmpty(this.userInfo));
      return !this.isVisitor && !isEmpty(this.userInfo);
    },
  },
};
</script>


<style scoped>
.redeemCode {
  padding: 24px 30px;
}
.redeemCode h2 {
  font-size: 24px;
  font-weight: bold;
  line-height: 33px;
  color: rgba(116, 179, 250, 1);
  margin-bottom: 56px;
}
.redeemCode .primary {
  margin-top: 48px;
}
.tips {
  margin-top: 48px;
}
.tips h3 {
  color: #98b1bc;
  font-size: 14px;
  font-weight: bold;
  flex: 0 0 auto;
  padding: 0 16px;
}
.tips p {
  font-size: 13px;
  color: #575757;
  line-height: 20px;
}
.tips .container {
  display: flex;
  align-items: center;
  line-height: 22px;
  margin-bottom: 12px;
}
.tips .container span {
  display: inline-block;
  flex: 1 1 auto;
  height: 1px;
  background: #6a92a4;
}
.tel {
  color: #74b3fa;
}
</style>
<style>
.redeem-content {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  padding: 0 16px;
}
</style>

